import { useEffect, useState } from "react";
import api from "@/api";
import { optionLabel, optionsWithCurrent } from "@/utils/archive";

/**
 * "Completed by": who did the task (customer point 61), chosen among the active users - the current one is kept
 * even when archived. `value` is a user id ("" for none chosen); onChange(id). The API records the signed-in user as
 * who registered it. Loads the users unless they are given (`users`). `placeholder` names the empty choice; without
 * it there is none.
 */
export default function CompletedBySelect({ id = "completed-by-select", value, onChange, users: given, placeholder, disabled = false }) {
  const [loaded, setLoaded] = useState([]);
  useEffect(() => {
    if (given) return;
    let alive = true;
    api.post("/masterdata/users")
      .then((res) => { if (alive) setLoaded(Array.isArray(res.data) ? res.data : []); })
      .catch(() => { if (alive) setLoaded([]); });
    return () => { alive = false; };
  }, [given]);
  const users = given ?? loaded;
  const options = optionsWithCurrent(users, value).slice().sort((a, b) => String(a.name || "").localeCompare(String(b.name || "")));

  return (
    <select
      id={id}
      aria-label="Completed by"
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))}
      disabled={disabled}
      className="min-h-10 w-full rounded border px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800"
    >
      {placeholder !== undefined && <option value="">{placeholder}</option>}
      {/* The chosen user before the list has loaded, so the value is never lost */}
      {value && !options.some((u) => Number(u.id) === Number(value)) && <option value={value}>…</option>}
      {options.map((u) => (
        <option key={u.id} value={u.id}>{optionLabel(u, `${u.name}${u.initials ? ` (${u.initials})` : ""}`)}</option>
      ))}
    </select>
  );
}
